import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import { 勘定科目ListItemResponse } from '@/openapi/user';

import C勘定科目大分類Select from '@/components/勘定科目/大分類Select/勘定科目大分類Select.vue';
import C勘定科目中分類Select from '@/components/勘定科目/中分類Select/勘定科目中分類Select.vue';

import 勘定科目カテゴリComponentMixin from '@/entries/user/mixins/勘定科目カテゴリComponentMixin';
import EditRowMixin from '@/entries/user/mixins/EditRowMixin';

export default mixins(勘定科目カテゴリComponentMixin, EditRowMixin).extend({
  name: 'C勘定科目TableEditRow',

  components: {
    C勘定科目大分類Select,
    C勘定科目中分類Select,
  },

  props: {
    edit勘定科目: {
      type: Object as PropType<勘定科目ListItemResponse>,
      required: true,
    },
    buttons: {
      type: Boolean,
      default: true,
    },
  },
});
